import { SlotGridType } from 'api/definitions/slotdates/types';

const reducer = (state: WtrState, action: { slotGridType: SlotGridType }) => ({
  ...state,
  selectedSlotGridType: action.slotGridType,
});

export default reducer;
